import { billing } from '@saucelabs/sl-util-axios';

import { ServerPlan } from '../../records/Plan';

export const fetchPlans = (): AsyncResponse<ServerPlan[]> => billing.get<ServerPlan[]>('/plans');
